import React from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import {Form, Input} from 'antd'
import Query from 'components/shared/Query'
import Button from 'components/shared/Button'
import AvatarUploader from 'components/shared/AvatarUploader'

const brokerQuery = gql`
  query SlideshowBrokerQuery {
    viewer {
      id
      broker {
        id, name, phone
      }
    }
  }
`

const setSlideshowInputMutation = gql`
  mutation SetSlideshowInput($input: SetSlideshowInputInput!) {
    SetSlideshowInput(input: $input) {
      product {
        id
        state
        requiresUserInput
        canProvideUserInput
        ...on SlideshowProduct {
          slideshowFacts
        }
      }
    }
  }
`

const BrokerDetailsFormFields = ({isSubmitting, handleSubmit, defaultValues = {}}) => {
  const [form] = Form.useForm()

  return (
    <Form form={form} layout="vertical" initialValues={defaultValues} onFinish={handleSubmit}>
      <Form.Item name="agentName" label="Navn">
        <Input />
      </Form.Item>

      <Form.Item name="agentPhone" label="Telefon">
        <Input />
      </Form.Item>

      <Form.Item name="agentProfilePhotoUrl" label="Profilbilde (min. 1000px)">
        <AvatarUploader />
      </Form.Item>

      <Form.Item>
        <Button
          type="action"
          htmlType="submit"
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Send til produksjon
        </Button>
      </Form.Item>
    </Form>
  )
}

const BrokerDetailsForm = BrokerDetailsFormFields

const BrokerDetails = ({product}) => {
  return (
    <Mutation
      mutation={setSlideshowInputMutation}
    >
      {(setSlideshowInput, {loading: isSubmitting}) => (
        <Query
          inlineLoading
          query={brokerQuery}
        >
          {({getData}) => {
            const defaultValues = {
              name: getData('viewer.broker.name'),
              phone: getData('viewer.broker.phone'),
            }

            return (
              <div className="broker-details">
                <BrokerDetailsForm
                  isSubmitting={isSubmitting}
                  defaultValues={defaultValues}
                  handleSubmit={(data) => {
                    return setSlideshowInput({
                      variables: {
                        input: {
                          productId: product.id,
                          facts: JSON.stringify(data),
                          sendToProduction: true,
                        }
                      }
                    })
                  }}
                />
              </div>
            )
          }}
        </Query>
      )}
    </Mutation>
  )
}

export default BrokerDetails
